import { createSlice } from '@reduxjs/toolkit';

const leadersSlice = createSlice({
    name: 'leaders',
    initialState: {
        list: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 1,
        },
        createLeader: { loading: false, error: null },
        updateLeader: { loading: false, error: null },
        importLeadersCsv: { loading: false, error: null },
    },
    reducers: {
        fetchLeadersStart: (state, action) => {
            state.list.loading = true;
            state.list.error = null;
            if (action.payload.page === 1) {
                state.list.data = [];
            }
        },
        fetchLeadersSuccess: (state, action) => {
            state.list = { ...action.payload, loading: false };
        },
        fetchLeadersFail: (state, action) => {
            state.list.loading = false;
            state.list.error = action.payload;
        },
        createLeaderStart: (state) => {
            state.createLeader.loading = true;
            state.createLeader.error = null;
        },
        createLeaderSuccess: (state) => {
            state.createLeader.loading = false;
        },
        createLeaderFail: (state, action) => {
            state.createLeader.loading = false;
            state.createLeader.error = action.payload;
        },
        updateLeaderStart: (state) => {
            state.updateLeader.loading = true;
            state.updateLeader.error = null;
        },
        updateLeaderSuccess: (state) => {
            state.updateLeader.loading = false;
        },
        updateLeaderFail: (state, action) => {
            state.updateLeader.loading = false;
            state.updateLeader.error = action.payload;
        },
        importLeadersCsvStart: (state) => {
            state.importLeadersCsv.loading = true;
            state.importLeadersCsv.error = null;
        },
        importLeadersCsvSuccess: (state) => {
            state.importLeadersCsv.loading = false;
        },
        importLeadersCsvFail: (state, action) => {
            state.importLeadersCsv.loading = false;
            state.importLeadersCsv.error = action.payload;
        },
    },
});

export const {
    fetchLeadersStart,
    fetchLeadersSuccess,
    fetchLeadersFail,
    createLeaderStart,
    createLeaderSuccess,
    createLeaderFail,
    updateLeaderStart,
    updateLeaderSuccess,
    updateLeaderFail,
    importLeadersCsvStart,
    importLeadersCsvSuccess,
    importLeadersCsvFail,
} = leadersSlice.actions;

export default leadersSlice.reducer;
